import * as React from "react";

import FormCard from "@impero-com/common/components/formCard";
import FormCardContainer from "@impero-com/common/components/formCardContainer";
import RightSideIcon from "@impero-com/common/components/rightSideIcon";
import passwordSvg from "@impero-com/common/img/password-login.svg";
import { t } from "@impero-com/common/utils/i18n";
import { OrgCookie } from "@impero-com/common/utils/orgCookie";
import { loginRedirectToRoot } from "@impero-com/common/utils/url";
import { Button, CardFooter, FormSubtitle, FormTitle } from "@impero-com/ui";
import { Typography } from "antd";
import FormItem from "antd/es/form/FormItem";

interface DisplayRecoveryCodeProps {
    recoveryCode: string;
    orgCookie: OrgCookie;
}

class DisplayRecoveryCode extends React.PureComponent<DisplayRecoveryCodeProps> {
    render = () => {
        const { orgCookie, recoveryCode } = this.props;
        return (
            <FormCardContainer
                rightSide={
                    <RightSideIcon
                        icon={passwordSvg}
                        customImages={true}
                        orgCookie={orgCookie}
                    />
                }
            >
                <FormTitle title={t("Setup2FA_RecoveryCode")} />
                <FormSubtitle subtitle={t("Setup2FA_RecoveryDescription")} />
                <FormCard>
                    <FormItem>
                        <DisplayRecoveryCodeTitle recoveryCode={recoveryCode} />
                    </FormItem>
                    <FormItem>
                        <Button
                            id="copy-button"
                            onClick={this.handleLogin}
                            variant="primary"
                            block
                        >
                            {t("Login_LoginButton")}
                        </Button>
                    </FormItem>
                </FormCard>
                <CardFooter />
            </FormCardContainer>
        );
    };

    handleLogin = () => {
        loginRedirectToRoot();
    };
}

interface DisplayRecoveryCodeTitleProps {
    recoveryCode: string;
}

function DisplayRecoveryCodeTitle(props: DisplayRecoveryCodeTitleProps) {
    const { Title } = Typography;
    return (
        <Title code={true} level={4} copyable>
            {props.recoveryCode}
        </Title>
    );
}

export { DisplayRecoveryCode, DisplayRecoveryCodeTitle };
